module.exports = __webpack_public_path__ + "static/spraydays-326dcc08b6e754c338fed6fa9ad8aff5.png";